define('responsive-gameday/views/render/VideosViewRender',['require','exports','module','./ViewRender','Wax/get!view-templates/videos/videos','Wax/get!view-templates/videos/playlist','Wax/get!view-templates/videos/videoAds','Wax/get!view-templates/videos/videocorePlayer'],function(require,exports,module){
    var ViewRender = require('./ViewRender'),
        Superclass;

    function VideosViewRender(){
        Superclass.constructor.call(this,
            require('Wax/get!view-templates/videos/videos'),{
                playlistView        : require( 'Wax/get!view-templates/videos/playlist' ),
                videoAdsView        : require( 'Wax/get!view-templates/videos/videoAds' ),
                videocorePlayerView : require( 'Wax/get!view-templates/videos/videocorePlayer' )
            }
        );
    }
    ViewRender.spawn(VideosViewRender);

    Superclass=VideosViewRender.superclass;

    return VideosViewRender;
});
